import { render, staticRenderFns } from "./TreeMenuSelector.vue?vue&type=template&id=04c8f66e"
import script from "./TreeMenuSelector.vue?vue&type=script&lang=js"
export * from "./TreeMenuSelector.vue?vue&type=script&lang=js"
import style0 from "./TreeMenuSelector.vue?vue&type=style&index=0&id=04c8f66e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports